<template>
  <Transition name="modal">
    <div v-if="showModal" class="" id="modalPopupUpgrade">
      <div class="modal-container">
        <div class="modal-header">
          <button class="close-black" @click="closeModal()">
            <img
              src="https://api.belladasemana.com.br/storage/2015/ico_x_black-t.png"
              alt="Close"
              class="close-modal"
            />
          </button>
        </div>
        <div class="modal-body text-center">
          <div class="orange-text">
            {{ translate.modalUpgradeText0 }}
          </div>
          <div class="orange-text">
            {{ translate.modalUpgradeText1 }}
          </div>
          <div class="black-text pt-4" v-if="isMobile()" style="line-height: 25px;">
            {{ translate.modalUpgradeText2 }}<br><b>{{ planName }}</b> 
          </div>
          <div class="black-text pt-4" v-else>
            {{ translate.modalUpgradeText2 }} <b>{{ planName }}</b> {{ translate.modalUpgradeText3 }} 
          </div>
          <div class="black-text pb-4" v-if="isMobile()">
            {{ translate.modalUpgradeText3 }} 
            <span class="orange-saldo">{{ route.params.language == 'pt-br' ? 'R$' : '$' }} {{ bonusUpgrade.toString().split('.')[0] }},</span>
            <span class="orange-saldo orange-saldo-cents">{{ bonusUpgrade.toString().split('.')[1] }}</span>
            <br>
            <span style="line-height: 30px;">{{ translate.modalUpgradeText4 }}</span>
          </div>
          <div class="black-text pb-4" v-else>
            <span class="orange-saldo">{{ route.params.language == 'pt-br' ? 'R$' : '$' }} {{ bonusUpgrade.toString().split('.')[0] }},</span>
            <span class="orange-saldo orange-saldo-cents">{{ bonusUpgrade.toString().split('.')[1] }}</span>
            {{ translate.modalUpgradeText4 }}
          </div>
          <div class="bt-upgrade" @click="redirectPage('language-assine')">
            {{ translate.modalUpgradeText5 }}
            <img :src="hand" class="hand" />
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { isMobile } from "~/shared/utils/mobile";
import translaters from "@/tradutors/myaccount";
import api from "@/api";
import hand from 'assets/img/hand.png';

const storeUser = userStore();
const storePlan = planStore();
const bonusUpgrade = computed(() => storePlan.saldoUpgrade);
const translate = computed(() =>
  route.params.language === "pt-br" ? translaters.portugues : translaters.ingles
);
const router = useRouter();
const route = useRoute();
const showModal = ref(false);
const planName = ref('');

onMounted(() => {

  if (
    storeUser.isActiveUser == true &&
    route.name != "language-assine" &&
    route.name != "language-assine-period" &&
    route.name != "language-assine-turbo" &&
    route.name != "language-assine-account" &&
    route.name != "language-assine-checkout" &&
    route.name != "language-assine-checkout-success"
  ) {
    getPopupUpgrade();
  }

});

async function getPopupUpgrade() {
  api.get(`v1/home/getPopupUpgrade`).then(({ data }) => {
    if (
      document.getElementById("modalPromoMain") == null &&
      document.getElementById("modalPromoFooter") == null &&
      document.getElementById("modalSubscribeExit") == null &&
      document.getElementById("modalLegalWarning") == null &&
      document.getElementById("modalBannerPlanUnique") == null &&
      document.getElementById("modalNotification") == null &&
      document.getElementById("modalLgpdAccept") == null &&
      document.getElementById("modalNewsletter") == null &&
      document.getElementById("modalPopupInvite") == null &&
      document.getElementById("modalPopupCredit") == null &&
      data.show
    ) {
      api
        .get(`auth/isOrderActiveUser?locale=${route.params.language ?? ""}`)
        .then(({ data: { orderActive } }) => {
          if (orderActive.plan_type_name != "Gold" && parseFloat(bonusUpgrade.value) > 0) {
            planName.value = orderActive.plan_name;
            showModal.value = true;
            api.post(`v1/home/updatePopupUpgrade`);
          }
        });
    }
  });
}

function closeModal() {
  showModal.value = false;
}

function redirectPage(name: string) {
  router.push({ name, params: { language: route.params.language } });
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  transition: opacity 0.3s ease;
}

.modal-container {
  position: fixed;
  z-index: 9998;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 680px;
  margin: auto;
  padding: 40px 10px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  border: 1px solid transparent;
  border-radius: 54px;
  background: 
    linear-gradient(white, white) padding-box,
    linear-gradient(to bottom, #FF6000, #FFC39E) border-box;
  background-clip: padding-box, border-box; 
  background-origin: padding-box, border-box; 

}


.modal-header {
  display: block;
  text-align: center;
}

.modal-body {
  margin: 0;
  padding: 0px 0px;
}

.modal-default-button {
  float: right;
}

/*
* The following styles are auto-applied to elements with
* transition="modal" when their visibility is toggled
* by Vue.js.
*
* You can easily play with the modal transition by editing
* these styles.
*/

.modal-enter-from {
  opacity: 0;
}

.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.close-black {
  position: absolute;
  right: -25px;
  top: -56px;
  z-index: 1;
}

.orange-text {
  color: #ff6000;
  font-family: "Exo-2";
  font-weight: 700;
  font-size: 30px;
  letter-spacing: -1px;
  line-height: 100%;
}

.black-text {
  color: #000000;
  font-family: "Exo-2";
  font-weight: 500;
  font-size: 25px;
  letter-spacing: 0;
  line-height: 100%;
}

.orange-saldo {
  color: #ff6000;
  font-family: "Exo-2";
  font-weight: 700;
  font-size: 25px;
  letter-spacing: 0;
  line-height: 100%;
}

.orange-saldo-cents {
  font-size: 15px;
}

.bt-upgrade {
  background-color: #ff6000;
  color: #ffffff;
  font-family: "Exo-2";
  font-weight: 700;
  font-size: 18px;
  letter-spacing: 0;
  line-height: 20px;
  padding: 7px;
  border-radius: 7px;
  cursor: pointer;
  width: 255px;
  height: 40px;
  padding-top: 9px;
  margin: 0 auto;
}

.hand {
  width: 30px;
  position: absolute;
  right: -22px;
  bottom: -15px;
}

@media screen and (max-width: 769px) {
  .modal-container {
    width: 95%;
  }

  .close-modal {
    width: 25px;
    height: 25px;
    margin: 5px;
  }

  .orange-text {
    font-size: 20px;
  }
  .black-text {
    font-size: 18px;
  }

  .close-black {
    right: -20px;
    top: -63px;
  }  
}
</style>
